export default "__VITE_ASSET__a5339e7d__"